window._AutofillCallbackHandler = window._AutofillCallbackHandler || function(){}

// window load function
window.onload = function() {
    // Wait for 2 seconds before loading the script
    setTimeout(function() {
        document.getElementById("rebuy-smart-cart-announcement-bar").classList.add("ge-hide-display-none");
    }, 2000);

    setTimeout(function() {
      document.getElementById("rebuy-smart-cart-announcement-bar").forEach(function(element) {
        element.classList.add("ge-hide-display-none");
      });
    }, 2000);

    // Wait for 3 seconds before loading the script
    setTimeout(function() {
        document.getElementsByClassName("rebuy-cart__flyout-item-subscription")[0].classList.add("ge-hide-display-none")
        document.getElementsByClassName("rebuy-cart__flyout-item-subscription").classList.add("ge-hide-display-none")
    }, 3000);

    setTimeout(function() {
      document.getElementsByClassName("rebuy-cart__flyout-item-subscription").forEach(function(element) {
        element.classList.add("ge-hide-display-none");
      });
    }, 3000);
};

// for each element clicked
document.addEventListener("click", function(event) {
    var element = event.target;
    var elementClass = element.className;
    if (elementClass === "block-swatch__item") {
        setTimeout( function () {
            // const productMedia = document.querySelector("product-media");
            // const variantImage = productMedia.innerHTML;
            // productMedia.innerHTML = variantImage;
            // refresh page
            window.location.reload();
        }, 100);
    }
});


// for each select with class product-form__select option change
document.addEventListener("change", function(event) {
    var element = event.target;
    if (element.classList.contains("block-swatch-select")) {
        setTimeout(function() {
            window.location.reload();
        }, 100);
    }
});

document.addEventListener("change", function(event) {
    var element = event.target;
    var elementClass = element.className;
    if (elementClass === "product-form__select") {
        setTimeout( function () {
            window.location.reload();
        }, 100);
    }
    if (element.classList.contains("block-swatch__radio")) {
        setTimeout(() => {
            window.location.reload();
        }, 100);
    }
});
// Rebuy Widget Free Gift
document.addEventListener('rebuy:cart.add', function(event){
  // Check if this is a subscription product by looking at selling_plan_allocation
  const isSubscription = event.detail.item.selling_plan_allocation != undefined && event.detail.item.selling_plan_allocation != null;   
  console.log('Is subscription product:', isSubscription);
  const existingContainer = document.querySelector('div[data-rebuy-id="217079"]');
  if (isSubscription) {
      if (existingContainer) {
          // add element with div[data-rebuy-id="216644"] in bottom of html body
          const childElements = existingContainer.querySelectorAll('div#rebuy-widget-217079');
          childElements.forEach(function(childElement) {
              childElement.style.display = 'block';
          });
      }
  } else {
      if (existingContainer) {
          const closeButton = existingContainer.querySelector('.rebuy-modal-close');
          if (closeButton) {
              closeButton.click();
          }
          const childElements = existingContainer.querySelectorAll('div#rebuy-widget-217079');
          childElements.forEach(function(childElement) {
              childElement.style.display = 'none';
          });
      }
  }
}); 

